import styled from 'styled-components';

export const StyledUserInfoTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
`;

export const StyledDataBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 74px);
  gap: 10px;
`;

export const StyledDataContent = styled.div`
  border-radius: 4px;
  border: 0.5px solid #333;
  background: rgba(0, 0, 0, 0.9);
  padding: 7px;

  .content-title {
    color: var(--color-white);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    > img {
      width: 28px;
      height: 28px;
      object-fit: contain;
    }

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -5px;
      transform: translateX(-50%);
      width: 62px;
      height: 1px;
      background-color: #3a3a3a;
    }
  }

  .content-desc {
    margin-top: 14px;
    color: var(--color-white);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &.required {
      color: #ff6a0d;
    }

    > span {
      display: inline-block;
      color: var(--color-white);
      text-align: center;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;
